import Request from '../../../core/gd/data/request'
import {ViewType} from "../const/views/view-type";
import {PublicSharingType, SharedViewConfig} from "../../gd-modals/share-view/@types";

export default class ApiShareView {

    create(viewType: ViewType, title: string, config: SharedViewConfig, sharingType: PublicSharingType = PublicSharingType.VIEW) {

        const params = {
            viewType    : viewType,
            title       : title,
            config      : config,
            sharingType : sharingType
        }

        return new Request(this, 'POST', 'shared-view/create', params);
    }

    get(sharedViewId: ID) {
        return new Request(this, 'GET', 'shared-view/'+sharedViewId+'/info');
    }

    update(sharedViewId: ID, viewType: ViewType, title: string, config: SharedViewConfig) {
        return new Request(this, 'PUT', 'shared-view/'+sharedViewId+'/update', {viewType, title, config});
    }

    delete(sharedViewId: ID) {
        return new Request(this, 'POST', 'shared-view/'+sharedViewId+'/delete');
    }
}